import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LL } from 'i18n/i18n.service';

@Component({
  selector: 'cs-nutrition-stats-row',
  templateUrl: 'cs-nutrition-stats-row.html',
  host: { 'class': 'nutrition-stats-row' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsNutritionStatsRow {
  protected LL = LL;

  @Input() dailyAvg: string | undefined;
  @Input() mealCalories: string | undefined;
  @Input() cutMealCalories: string | undefined;
  @Input() bulkMealCalories: string | undefined;

  get isCyclingEnabled(): boolean {
    return this.cutMealCalories != null && this.bulkMealCalories != null;
  }
}
